import { Location } from '@components/Hotels/types';
import { environment } from '@helpers/environment';
import { DayRoomIcon, HotelIcon, PoolIcon, RobeIcon } from '@resortpass/solar-icons';
import React from 'react';

const DEFAULT_OPTIONS_POPULAR_TEXT = 'Popular';
const DEFAULT_OPTIONS_CURRENT_LOCATION_VALUE = 'current_location';

const SEARCH_DEFAULT_LOCATION_NAMES = [
  'Miami, FL',
  'Orlando, FL',
  'Fort Lauderdale, FL',
  'San Diego, CA',
  'Phoenix, AZ',
  'Los Angeles, CA',
  'New York, NY',
  'San Juan, PR',
];

const SEARCH_DEFAULT_OPTIONS = [
  { value: DEFAULT_OPTIONS_POPULAR_TEXT, label: DEFAULT_OPTIONS_POPULAR_TEXT },
  { value: 'Miami, FL', label: 'Miami, FL' },
  { value: 'Orlando, FL', label: 'Orlando, FL' },
  { value: 'Fort Lauderdale, FL', label: 'Fort Lauderdale, FL' },
  { value: 'San Diego, CA', label: 'San Diego, CA' },
  { value: 'Phoenix, AZ', label: 'Phoenix, AZ' },
  { value: 'Los Angeles, CA', label: 'Los Angeles, CA' },
  { value: 'New York, NY', label: 'New York, NY' },
  { value: 'San Juan, PR', label: 'San Juan, PR' },
];

const SEARCH_DEFAULT_LOCATIONS: Location[] = [
  {
    id: 14,
    name: 'Miami, Florida',
    type: 'city',
    detailed_type: 'city',
    url: '/hotel-day-passes/Miami-14',
    parent_id: 6,
    parent_type: 'state',
    city_name: 'Miami',
    state_code: 'FL',
    country_code: 'US',
    indexName: environment.isProduction ? 'production_locations' : 'staging_locations',
    objectID: 'Miami, Florida',
    queryID: '58a700e14d4b3493128769b7b6b0ae59',
  },
  {
    id: 36,
    name: 'Orlando, Florida',
    type: 'city',
    detailed_type: 'city',
    url: '/hotel-day-passes/Orlando-36',
    parent_id: 6,
    parent_type: 'state',
    city_name: 'Orlando',
    state_code: 'FL',
    country_code: 'US',
    indexName: environment.isProduction ? 'production_locations' : 'staging_locations',
    objectID: 'Orlando, Florida',
    queryID: 'b16811f0490b200123f8cfe5523dac57',
  },
  {
    id: 15,
    name: 'Fort Lauderdale, Florida',
    type: 'city',
    detailed_type: 'city',
    url: '/hotel-day-passes/Fort-Lauderdale-15',
    parent_id: 6,
    parent_type: 'state',
    city_name: 'Fort Lauderdale',
    state_code: 'FL',
    country_code: 'US',
    indexName: environment.isProduction ? 'production_locations' : 'staging_locations',
    objectID: 'Fort Lauderdale, Florida',
    queryID: '04cc345452a525114e2c39e26c24cac2',
  },
  {
    id: 3,
    name: 'San Diego, California',
    type: 'city',
    detailed_type: 'city',
    url: '/hotel-day-passes/San-Diego-3',
    parent_id: 4,
    parent_type: 'state',
    city_name: 'San Diego',
    state_code: 'CA',
    country_code: 'US',
    indexName: environment.isProduction ? 'production_locations' : 'staging_locations',
    objectID: 'San Diego, California',
    queryID: 'b52be142c52c953d426f0c260bae32fc',
  },
  {
    id: 12,
    name: 'Phoenix, Arizona',
    type: 'city',
    detailed_type: 'city',
    url: '/hotel-day-passes/Phoenix-12',
    parent_id: 7,
    parent_type: 'state',
    city_name: 'Phoenix',
    state_code: 'AZ',
    country_code: 'US',
    indexName: environment.isProduction ? 'production_locations' : 'staging_locations',
    objectID: 'Phoenix, Arizona',
    queryID: '2c72badf5589c93210d8a6a6d7a34d00',
  },
  {
    id: 4,
    name: 'Los Angeles, California',
    type: 'city',
    detailed_type: 'city',
    url: '/hotel-day-passes/Los-Angeles-4',
    parent_id: 4,
    parent_type: 'state',
    country_code: 'US',
    city_name: 'Los Angeles',
    state_code: 'CA',
    indexName: environment.isProduction ? 'production_locations' : 'staging_locations',
    objectID: 'Los Angeles, California',
    queryID: 'd98e6be1801d396f5a7cfcbda4e57e54',
  },
  {
    id: 123,
    name: 'New York, New York',
    type: 'city',
    detailed_type: 'city',
    url: '/hotel-day-passes/New-York-123',
    parent_id: 38,
    parent_type: 'state',
    country_code: 'US',
    city_name: 'New York',
    state_code: 'NY',
    indexName: environment.isProduction ? 'production_locations' : 'staging_locations',
    objectID: 'New York, New York',
    queryID: '8199572026f5c318b110159539c94844',
  },
  {
    id: 903,
    name: 'San Juan, Puerto Rico',
    type: 'city',
    detailed_type: 'city',
    url: '/hotel-day-passes/San-Juan-903',
    parent_id: 149,
    parent_type: 'state',
    country_code: 'US',
    city_name: 'San Juan',
    state_code: 'PR',
    indexName: environment.isProduction ? 'production_locations' : 'staging_locations',
    objectID: 'San Juan, Puerto Rico',
    queryID: 'bfde24cc4cf79d5e8115466b3b04e0fb',
  },
];

const SEARCH_DEFAULT_FILTERS = [
  {
    name: 'all',
    icon: <HotelIcon size={24} />,
  },
  {
    name: 'pool',
    icon: <PoolIcon size={24} />,
  },
  {
    name: 'spa',
    icon: <RobeIcon size={24} />,
  },
  {
    name: 'day room',
    icon: <DayRoomIcon size={24} />,
  },
];

export {
  SEARCH_DEFAULT_FILTERS,
  SEARCH_DEFAULT_LOCATIONS,
  DEFAULT_OPTIONS_POPULAR_TEXT,
  DEFAULT_OPTIONS_CURRENT_LOCATION_VALUE,
  SEARCH_DEFAULT_LOCATION_NAMES,
  SEARCH_DEFAULT_OPTIONS,
};
